import { c as _c } from "react/compiler-runtime";
import { INITIATIVE_PROPOSAL_STATUS_OPTIONS } from '@sizzlenz/shared';
import { FileText, MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';
interface InitiativeProposalSnapshotProps {
  proposalStatus?: string | null;
  onProvideFeedback?: () => void;
}
export function InitiativeProposalSnapshot(t0) {
  const $ = _c(13);
  const {
    proposalStatus,
    onProvideFeedback
  } = t0;
  let t1;
  if ($[0] !== proposalStatus) {
    t1 = INITIATIVE_PROPOSAL_STATUS_OPTIONS.find(opt => opt.value === proposalStatus);
    $[0] = proposalStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusOption = t1;
  const label = statusOption?.label || proposalStatus || "Not specified";
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      draft: "bg-gray-100 text-gray-700",
      submitted: "bg-blue-100 text-blue-800",
      assessing: "bg-yellow-100 text-yellow-800",
      accepted: "bg-green-100 text-green-800",
      rejected: "bg-red-100 text-red-800"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const colorMap = t2;
  const colorClass = proposalStatus ? colorMap[proposalStatus] || "bg-gray-100 text-gray-700" : "bg-gray-100 text-gray-500";
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-2"><h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-1.5"><FileText className="w-3.5 h-3.5" />This is a Proposed initiative</h3><p className="text-xs text-gray-600 leading-relaxed">It may have been created by one of your team to gauge interest, submitted by an approved partner, generated by Sizzle specifically for you, or a template flagged as a great match.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-sm text-gray-600">Status</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${colorClass}`;
  let t6;
  if ($[5] !== label || $[6] !== t5) {
    t6 = <div className="flex items-center gap-2">{t4}<span className={t5}>{label}</span></div>;
    $[5] = label;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onProvideFeedback) {
    t7 = onProvideFeedback && <Button variant="outline" size="sm" onClick={onProvideFeedback} className="gap-1.5 cursor-pointer"><MessageSquare className="w-3.5 h-3.5" />Provide Feedback</Button>;
    $[8] = onProvideFeedback;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="space-y-4">{t3}<div className="border-t border-gray-200 pt-3 flex items-center justify-between">{t6}{t7}</div></div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}